//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniqBy from 'lodash/uniqBy'
import RbSelect from '@/elements/forms/rb-select.vue'

import { centerGoogleMapOnCountry } from '@/scripts/libs/google-maps'
import { required } from 'vuelidate/lib/validators'
import wcs from '@/scripts/libs/wcs'
import { COUNTRY_LIST } from '@/scripts/constants/countryList'
import { filterCountriesByGroup } from '@/scripts/libs/store-locator'
import { getRoeCookie } from '@/scripts/libs/country-selector'
import { mapGetters } from 'vuex'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { WcsAkamaiCookies } from '@/scripts/libs/wcs/types/akamai-cookies'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
const { storeId } = wcs.getStoreConfig()

export default {
  name: 'rb-store-locator-country-dropdown',
  components: {
    RbSelect,
  },
  props: {
    googleMap: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      countries: [],
      dropdownOptions: [],
      selectedCountry: undefined,
      initialValue: undefined,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    getDefaultOptionValue() {
      const regions = this.countries.filter((country) => !this.dropdownOptions.includes(country))
      const region = regions.find((region) => region.value === NoEcommerce.getNoEcommerceCountry())
      return region?.value
    },
    getDefaultOptionLabel() {
      return this.translation('store_locator.choose_country')
    },
    isRoe() {
      return storeId === WcsStoreId.REST_OF_EUROPE
    },
  },
  validations: {
    selectedCountry: {
      required,
    },
  },
  watch: {
    selectedCountry(newVal) {
      if (newVal) {
        const countryCode = this.countries.find((country) => country.value === newVal)
        this.$emit('updateCountrySelection', countryCode.locale)
        this.centerMapOnCountry(countryCode.label, this.googleMap)
      }
    },
    googleMap(newVal) {
      const currentCountry = this.countries.find((country) => country.value === this.initialValue)
      this.initialValue && this.centerMapOnCountry(currentCountry.label, newVal)
      this.$emit('updateCountrySelection', currentCountry?.locale)
    },
  },
  mounted() {
    const allCountries = COUNTRY_LIST
    this.initialValue = this.getInitialValue()
    const countries = allCountries.filter((country) => !!country.akamaiCC)
    const filteredCountries = filterCountriesByGroup(countries)
    const mappedCountries = filteredCountries.map((country) => {
      return {
        label: country.label,
        value: country.akamaiCC,
        locale: this.mapCountryLocale(country.lang, country.akamaiCC),
      }
    })
    this.countries = uniqBy(mappedCountries, (country) => country.value)
    this.dropdownOptions = this.countries.filter(
      (country) => !WcsAkamaiCookies.NO_ECOMMERCE_REGIONS.includes(country.value)
    )
  },
  methods: {
    centerMapOnCountry(country, googleMap) {
      this.googleMap && centerGoogleMapOnCountry(country, googleMap)
    },
    getInitialValue() {
      if (this.isRoe) {
        return getRoeCookie()
      } else if (NoEcommerce.isStoreNoEcommerce()) {
        return NoEcommerce.getNoEcommerceCountry()
      }
    },
    mapCountryLocale(locale, akamaiCC) {
      const splitLocale = locale?.split('-')
      const lang = splitLocale[0]
      const newLocale = `${lang}-${akamaiCC}`
      return newLocale
    },
  },
}
